import React , {Component} from 'react';
import Skeleton from 'react-loading-skeleton';
class HomeLoaderV3 extends Component{
    render(){
        return(
            <div>
                <div className="row">
                    <div className="col">
                        <Skeleton count={1} height={176}/>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col">
                        <Skeleton count={1} height={60}/>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col">
                        <div className="section-custom-1">
                            <div className="row mb-5">
                                <div className="col">
                                    <div className="title-custom-1">
                                        شعبه‌ها
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12 mb-4">
                                    <Skeleton count={1} height={110}/>
                                </div>
                                <div className="col-12 mb-4">
                                    <Skeleton count={1} height={110}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}


export default HomeLoaderV3;